var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import id from "@irati/utils/id";
import { Recognition as RecognitionField } from "@irati-web/fields/poll/votes";
import { validatedScreen } from "@irati/utils/validation";
import { commentSchema } from "@irati-web/fields/poll/votes/validation";
import { ValidationButton, Hidden } from "@irati/ui/src/FormItem";
import ErrorText from "@irati/ui/src/ErrorText";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import CreateCommentMutation from "@irati/recognition/apollo/mutation/Comment/Create";
import tracking from "@irati-tracking/recognition/shared";
import { Form } from "../layouts";
var CreateComment = /** @class */ (function (_super) {
    __extends(CreateComment, _super);
    function CreateComment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            message: ""
        };
        _this.handleChange = function (message) { return _this.setState({
            message: message
        }); };
        _this.handleCommentCreationComplete = function () {
            tracking.commentPollAndRecognition();
        };
        _this.handleCommentCreationError = function (response) {
            tracking.errorsComment(response);
        };
        return _this;
    }
    CreateComment.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, intl = _a.intl, inputRef = _a.inputRef;
        var message = this.state.message;
        var hasComments = item.comments.results.length > 0;
        var fieldProps = hasComments ? {
            autoFocus: false
        } : {
            autoFocus: true
        };
        return (React.createElement(CreateCommentMutation, { item: item, message: message, onCompleted: this.handleCommentCreationComplete, onError: this.handleCommentCreationError }, function (onClick, apolloState) { return (React.createElement(Form, null,
            React.createElement(RecognitionField, __assign({ onChange: _this.handleChange, value: message, placeholder: intl.formatMessage({ id: "recognition.popup.shared.comments.placeholder" }), inputRef: inputRef }, fieldProps)),
            React.createElement(Hidden, { name: "hidden-recognition", value: message, validation: commentSchema(intl) }),
            apolloState.error && (React.createElement("div", null,
                React.createElement(ErrorText, null, apolloState.errorMsg))),
            React.createElement(ValidationButton, { id: id("submit", _this.props), onClick: onClick, apolloState: apolloState, full: true, primary: true },
                React.createElement(FormattedMessage, { id: "recognition.popup.shared.comments.comment" })))); }));
    };
    CreateComment.defaultProps = {
        id: "leave-comment",
        inputRef: function () { }
    };
    return CreateComment;
}(Component));
export default injectIntl(validatedScreen(CreateComment, "CreateComment"));
